<template>
  <div class="pane content-tree" :class="treeWrap" ref="box1" id="box1">
    <div class="ly-list tree-view">
      <div class="ly-list-top">
        <div class="ly-title">
          <h3 v-if="!isToggle1" class="title-sub">
            수신그룹 유형
          </h3>
          <el-button class="btn-toggle" @click="onTreeView()" v-if="!popup">
            <i v-if="isToggle1" class="el-icon-arrow-right"></i>
            <i v-else class="el-icon-arrow-left"></i>
          </el-button>
        </div>
        <div v-if="!isToggle1" class="ly-filter">
          <idc-search-catalog
            @filterServiceCatalogKeyword="getFilterKeyword"
          />
          <!-- <div class="ly-sort">
            <div class="total">
              <span>{{ $t("messages.all") }}</span>
              <span class="total-num">{{treeSize}}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="ly-list-content scrollY-auto" :class="popup?'popup':''" v-show="!isToggle1">
        <idc-tree
          :treeList="treeList"
          :reg="!popup&&!selectPopup?'msgGroup':''"
          @msgGroupRegist="msgGroupRegist"
          @msgGroupModify="msgGroupModify"
          @node-click="nodeClick"
          :show-checkbox="false"
          ref="tree"
        />
      </div>
      <div slot="footer" class="ly-detail-footer" v-if="popup">
        <el-button type="save" @click="selectMsgGroupCd">
          {{ $t("messages.plSelectOp") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcTree from "@/components/common/IdcTree";
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";

export default {
  mixins: [commonMixin],
  components: {
    IdcTree,
    IdcSearchCatalog
  },
  props: {
    popup: {
      type: Boolean,
      default: false
    },
    selectPopup: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$store.dispatch('msgGroupManageStore/getMsgGroupCdList');
  },
  computed: {
    treeList() {
      const root = {id : 3291, label: "메세지 수신 분류", menuBtn: false, children: [] };
      let list = this.$store.getters['msgGroupManageStore/getMsgGroupCdList'];
      list = this.setElTreeKeyData(list, "cd", "upCd", "cdHnglNm");
      this.setTreeList(root, list);
      return [root];
    },
    treeSize() {
      return this.$store.getters['msgGroupManageStore/getMsgGroupCdList'].length + 1;
    }
  },
  data() {
    return {
      selectMsgGroup: {}
    }
  },
  methods: {
    msgGroupRegist(data) {
      this.$store.commit('msgGroupManageStore/setCurrentmsgGroupCd', {
        upCd: data.id,
        cdHnglNm: '',
        cdEngNm: '',
        useYn: 'Y',
        delYn: 'N',
      });
      this.$store.commit('popupManageStore/setModalRegistMsgGroup', true);
    },
    msgGroupModify(data) {
      this.$store.commit('msgGroupManageStore/setCurrentmsgGroupCd', data.data);
      this.$store.commit('popupManageStore/setModalRegistMsgGroup', true);
    },
    nodeClick(cd) {
      if (this.popup) {
        if (cd.data) {
          this.selectMsgGroup = cd.data;
        } else {
          this.selectMsgGroup = {
            cd: cd.id,
            cdHnglNm: cd.label
          };
        }
      } else {
        this.$store.commit("msgGroupManageStore/setCurrentTreeCd", cd.data || {})
      }
    },
    getFilterKeyword(keyword) {
      this.$refs.tree.$refs.tree.filter(keyword);
    },
    selectMsgGroupCd() {
      if (Object.keys(this.selectMsgGroup).length === 0) {
        alert("수신그룹을 선택하세요.");
        return;
      }
      this.$EventBus.$emit('selectMsgGroupCd', this.selectMsgGroup);
      this.$store.commit('popupManageStore/setModalSelectMsgGroup', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  height: 350px;
}
</style>